import z from "zod";

/* IMPORTANT: Property names are snake_case to match the analytics event payload */

export const eventNameSchema = z
  .string()
  .nonempty("Event name is required")
  .max(40, "Event name must be at most 40 characters long");

export const flowLoadedSchema = z.object({
  flow_label: z.string().nonempty("Label is required"),
  responder_uuid: z.string().nonempty("Responder UUID is required"),
});

export const flowFinalizedSchema = z.object({
  flow_label: z.string().nonempty("Label is required"),
  responder_uuid: z.string().nonempty("Responder UUID is required"),
});

export const stepCompletedSchema = z.object({
  flow_label: z.string().nonempty("Label is required"),
  responder_uuid: z.string().nonempty("Responder UUID is required"),
  step_id: z.string().nonempty("Step ID is required"),
  step_index: z.number().int().nonnegative("Step index must be a non-negative integer"),
});

export const careplanProductWhyRecommendedViewedSchema = z.object({
  sku: z.string().nonempty("Sku is required"),
});

export const careplanProductCartClickedSchema = z.object({
  sku: z.string().nonempty("Sku is required"),
});

export const cartLineQuantityChangedSchema = z.object({
  sku: z.string().nonempty("Sku is required"),
  from: z.number().int().nonnegative(),
  to: z.number().int().nonnegative(),
});

export const cartLineRestoredSchema = z.object({
  sku: z.string().nonempty("Sku is required"),
});

export const postPurchaseRecommendationsUpsellProductViewedSchema = z.object({
  variant_id: z.string().nonempty("Variant ID is required"),
});
